import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import "firebase/auth";
import { db } from "./db";
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    coach: null,
    loginAttempts: 0,
    attendingEvents: [],
    gradYear: '',
    position: ''
  },
  mutations: {
    setCoach(state, coachDoc) {
      state.coach = { ...coachDoc.data, id: coachDoc.id, ref: coachDoc.ref };
    },
    logout(state) {
      state.coach = null;
    },
    updateCoach(state, payload) {
      state.coach.firstName = payload.firstName;
      state.coach.lastName = payload.lastName;
      state.coach.phone = payload.phone;
    },
    incrementAttempts(state) {
      // state.loginAttempts += 1;
      // if (state.loginAttempts > 1) {
      //   window.open("https://qrco.de/bb97p1", "_blank");
      // }
      // console.log(state.loginAttempts);
    },
    setAttendingEvents(state, events) {
      state.attendingEvents = [...events]
    },
    setGradYear(state, gradYear) {
      state.gradYear = gradYear
    },
    setPosition(state, position) {
      state.position = position
    },
    clearFilters(state) {
      state.position = '';
      state.gradYear = '';
    }
  },
  actions: {
    login({ dispatch, commit }, credentials) {
      return firebase.auth()
        .signInWithEmailAndPassword(credentials.email, credentials.password)
        .then(res => {
          return dispatch('getCoachDoc', res.user.uid);
        })
        .catch((error) => {
          if (error.code === 'auth/user-not-found') {
            // window.open("https://qrco.de/bb97p1", "_blank");
          }
          // commit('incrementAttempts');
          return error;
        })
    },
    getCoachDoc({ commit, dispatch, state }, uid) {
      return new Promise((resolve, reject) => {
        db.collection('coaches').doc(uid).get()
          .then(coach => {
            if (!coach.exists) { //if not coach.
              dispatch('logout');
            } else {
              if (!coach.data().emailVerified) {
                return dispatch('logout', { verificationMessage: true });
              } else {
                commit('setCoach', { id: uid, data: coach.data(), ref: coach.ref });
                dispatch('getAttendingEvents');
                if (!state.coach) {
                  coach.ref.set({
                    justLogged: true
                  }, { merge: true });
                }
              }
            }
            resolve();
          })
      })
    },
    getAttendingEvents({ commit, state }) {
      if (state.coach.attendingEvents && state.coach.attendingEvents.length > 0) {
        let attendingEvents = [];
        state.coach.attendingEvents.forEach(event => {
          event.get().then(res => {
            attendingEvents.push({
              ...res.data(),
              id: res.id,
              ref: res.ref,
              attending: true
            })
            commit('setAttendingEvents', attendingEvents)
          })
        });
      } else {
        commit('setAttendingEvents', [])
      }
    },
    updateCoach({ commit }, payload) {
      return new Promise((resolve, reject) => {
        db.collection("coaches")
          .doc(firebase.auth().currentUser.uid)
          .update({
            firstName: payload.firstName,
            lastName: payload.lastName,
            phone: payload.phone
          }).then(() => {
            commit("updateCoach", payload);
            resolve();
          }).catch(err => {
            reject(err);
          });
      })
    },
    addEvent(context, payload) {
      return new Promise((resolve, reject) => {
        db.collection("events").add({ ...payload }).then(() => {
          resolve();
        })
      })
    },
    logout({ commit }, payload) {
      return firebase.auth().signOut().then(res => {
        if (payload && payload.verificationMessage) {
          router.push('/verifyEmail');
        }
        commit('logout');
      })
    },
    recoverPassword({ commit }, email) {
      return new Promise((resolve, reject) => {
        firebase.auth().sendPasswordResetEmail(email)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
})
